import React from 'react';
import Typography from "@mui/material/Typography";
import Spacer from "../../Spacer";
import './Terms.scss';

const Terms = () => {
    return (
        <div className="terms-content">
            <Typography variant="h5" component="h1" gutterBottom>
                Terms of Use
            </Typography>

            <Typography variant="body1">
                Welcome. By accessing or using this website, you acknowledge that you have read, understood,
                and agree to be bound by these Terms of Use and our Privacy Policy. If you do not agree to these terms,
                you must refrain from using this website in any capacity.
            </Typography>
            <Spacer axis="vertical" size={20} />

            <section className="terms-section">
                <Typography variant="h6">1. Prohibited Use</Typography>
                <Typography variant="body2">
                    Users are strictly prohibited from engaging in unauthorized data collection activities, including but not limited to 
                    scraping, automated extraction, bulk downloading, or systematic reproduction of content from this website. 
                    Personal, non-commercial use such as casual browsing is permitted, provided it does not infringe upon the rights 
                    of Investitum or disrupt the functionality of the site.
                </Typography>
            </section>
            <Spacer axis="vertical" size={18}/>

            <section className="terms-section">
                <Typography variant="h6">2. Intellectual Property</Typography>
                <Typography variant="body2">
                    All content on this website, including text, images, graphics, logos, software, and other materials,
                    is protected under applicable intellectual property laws. Such content is owned by Aviani.org or its licensors.
                    Users may not reproduce, distribute, modify, or create derivative works from this content without prior written consent 
                    from Investitum.
                </Typography>
            </section>
            <Spacer axis="vertical" size={18}/>

            <section className="terms-section">
                <Typography variant="h6">3. No Warranties</Typography>
                <Typography variant="body2">
                    The information provided on this website is for general informational purposes only. While we make reasonable efforts 
                    to ensure accuracy, Investitum makes no warranties, express or implied, regarding the completeness, reliability, 
                    or suitability of the content. Users assume full responsibility for any reliance on information obtained from this site.
                </Typography>
            </section>
            <Spacer axis="vertical" size={18}/>

            <section className="terms-section">
                <Typography variant="h6">4. Financial Information</Typography>
                <Typography variant="body2">
                    Content on this website is not intended as financial advice. Users should consult a qualified financial professional 
                    before making any investment or financial decisions. Investitum does not accept any liability for financial outcomes 
                    resulting from actions taken based on the information provided on this website.
                </Typography>
            </section>
            <Spacer axis="vertical" size={18}/>

            <section className="terms-section">
                <Typography variant="h6">5. Third-Party Links</Typography>
                <Typography variant="body2">
                    This website may contain links to third-party websites for convenience. Such links do not imply endorsement or 
                    responsibility for the content, policies, or practices of those third-party sites. Users access external sites 
                    at their own risk.
                </Typography>
            </section>
            <Spacer axis="vertical" size={18}/>

            <section className="terms-section">
                <Typography variant="h6">6. Limitation of Liability</Typography>
                <Typography variant="body2">
                    To the fullest extent permitted by applicable law, Aviani.org, its affiliates, directors, employees, and agents 
                    shall not be liable for any direct, indirect, incidental, consequential, or punitive damages arising from the use 
                    of or inability to use this website, including any loss of profits, data, or goodwill.
                </Typography>
            </section>
            <Spacer axis="vertical" size={18}/>

            <section className="terms-section">
                <Typography variant="h6">7. Indemnification</Typography>
                <Typography variant="body2">
                    You agree to defend, indemnify, and hold harmless Aviani.org, its affiliates, directors, officers, employees, and agents 
                    from and against any claims, damages, obligations, losses, liabilities, costs, or expenses arising out of your use of the 
                    website, violation of these Terms, or infringement of any third-party rights.
                </Typography>
            </section>
            <Spacer axis="vertical" size={18}/>

            <section className="terms-section">
                <Typography variant="h6">8. Changes and Termination</Typography>
                <Typography variant="body2">
                    Aviani.org reserves the right to modify, suspend, or discontinue the website or these Terms of Use at any time, 
                    without prior notice. Continued access to or use of the website following any such changes constitutes acceptance 
                    of the updated terms.
                </Typography>
            </section>
            <Spacer axis="vertical" size={18}/>

            <section className="terms-section">
                <Typography variant="h6">9. Governing Law</Typography>
                <Typography variant="body2">
                    These Terms of Use shall be governed by and construed in accordance with the laws of the Republic of Croatia, 
                    without regard to its conflict of law principles. Any disputes arising under these Terms shall be subject to the 
                    exclusive jurisdiction of the courts located in Croatia.
                </Typography>
            </section>
            <Spacer axis="vertical" size={18}/>

            <section className="terms-section">
                <Typography variant="h6">10. Entire Agreement</Typography>
                <Typography variant="body2">
                    These Terms of Use, together with our Privacy Policy and any other legal notices published on the website,
                    constitute the entire agreement between you and Aviani.org concerning your use of the site, superseding any prior
                    agreements or understandings, whether written or oral.
                </Typography>
            </section>
            <Spacer axis="vertical" size={20}/>
        </div>
    )
}
export default Terms
